function mobileAside(width) {

    const button      = $('._js-mobile-sidebar-button');
    const body        = $('body');
    const activeClass = '_aside-opened';
    const navigation  = $('.mobile-sidebar');

    button.on('click', function(){
        if ( !body.hasClass(activeClass) ) {
            body.addClass(activeClass);
            console.log('!');
        } else {
            body.removeClass(activeClass);
            console.log('!!');
        }
    });
    $(window).on('resize', function(){
        if ( $(window).width() > width ) {
            body.removeClass(activeClass);
        }
    });
    $(document).on('mouseup touchend', function(e){
        if (
            !navigation.is(e.target) && navigation.has(e.target).length === 0
            && !button.is(e.target) && button.has(e.target).length === 0
        ) {
            body.removeClass(activeClass);
        }
    });
}